import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EvaluationRun } from '../models/quality.models';
import { LoadingStateComponent } from './loading-state.component';
import { EmptyStateComponent } from './empty-state.component';
import { ErrorStateComponent } from './error-state.component';

@Component({
  selector: 'app-evaluation-runs-widget',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    LoadingStateComponent,
    EmptyStateComponent,
    ErrorStateComponent,
  ],
  templateUrl: './evaluation-runs-widget.component.html',
  styleUrls: ['./evaluation-runs-widget.component.scss'],
})
export class EvaluationRunsWidgetComponent {
  @Input() title = '';
  @Input() runs: EvaluationRun[] = [];
  @Input() loading = false;
  @Input() error = '';
  @Input() initialLimit = 3;
  @Output() selectRun = new EventEmitter<string>();

  selected: EvaluationRun | null = null;
  showAll = false;

  get visibleRuns(): EvaluationRun[] {
    if (this.showAll || this.runs.length <= this.initialLimit) {
      return this.runs;
    }
    return this.runs.slice(0, this.initialLimit);
  }

  toggleShowAll(): void {
    this.showAll = !this.showAll;
  }

  isCompleted(run: EvaluationRun): boolean {
    return run.status.trim().toUpperCase() === 'COMPLETED';
  }

  select(run: EvaluationRun): void {
    this.selected = run;
    if (this.isCompleted(run)) this.selectRun.emit(run.runId);
  }
}
